<style lang="scss">
.single-option-select {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.on-demand-single-option label {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <span class="mr-4 feather-icon select-none relative switch-publish">
      <vs-switch v-model="params.data.IsPublished">
        <!--<span slot="on">Published</span>
        <span slot="off">Un-Published</span>-->
      </vs-switch>
    </span>
  </div>

  

</template>

<script>
import moduleAgendaManagement from "@/store/agenda-management/moduleAgendaManagement.js";
import ls from "@/common/localStorage";

let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
let Session_EventStartDate = ls.getSessionValueByKey("Session_EventStartDate");
let Session_EventEndDate = ls.getSessionValueByKey("Session_EventEndDate");
let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
export default {
  name: "CellRendererChangeStatusGroup",
  data(){
    return {
      popupOtherSettings: false,
      session_data: null,
      PlanDetails: null,
      sessionTypeId: null,
      sessionId: null,
      slectedTab: 0
    }
  }, 
  watch: {
    "params.data.IsPublished"() {
      this.$vs.loading();
      this.$store
        .dispatch("agendaManagement/updateStatus", {
          IsPublished: this.params.data.IsPublished,
          groups: [this.params.Group]
        })
        .then(() => {
          this.$vs.loading.close();
          this.showChangeStatusSuccess();
        })
        .catch(err => {
          this.$vs.loading.close();
        });
    },
  },
  methods: {
    
    editRecord(id) {
      //console.log(id);
      //id = window.btoa(id);
      this.$router
        .push({
          name: "session-edit",
          params: {
            sessionId: id
          }
        })
        .catch(() => {});

      /*
              Below line will be for actual product
              Currently it's commented due to demo purpose - Above url is for demo purpose

              this.$router.push("/apps/user/user-edit/" + this.params.data.id).catch(() => {})
            */
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete "${this.params.data.username}"`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      });
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      this.showDeleteSuccess();

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
      //   .then(()   => { this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "User Deleted",
        text: "The selected user was successfully deleted"
      });
    },
    showChangeStatusSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Status Changed",
        text: this.params.data.IsPublished ? "Group Published successfully" : "Group Unpublished successfully"
      });
    },
    
  },
  created(){
    if (!moduleAgendaManagement.isRegistered) {
      this.$store.registerModule("agendaManagement", moduleAgendaManagement);
      moduleAgendaManagement.isRegistered = true;
    }
    
  }
};
</script>
